import { ChangeDetectionStrategy, Component } from '@angular/core';
import { PopoverController } from '@ionic/angular';

@Component({
    selector: 'app-outras-operacoes',
    templateUrl: './outras-operacoes.popover.html',
    styleUrls: ['./outras-operacoes.popover.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class OutrasOperacoesPopover {
  public buttonColor: 'dark' | 'danger' = 'dark';
  public roles: OutrasOperacoesPopoverRoleEnum;

  constructor(
    private popoverCtrl: PopoverController
  ) { }

  public close(type: string) {
    this.popoverCtrl.dismiss('', type);
  }

  toggleColor() {
    if (this.buttonColor === 'dark') {
      this.buttonColor = 'danger';
    } else if (this.buttonColor === 'danger') {
      this.buttonColor = 'dark';
      this.close(OutrasOperacoesPopoverRoleEnum.CancelarPedido);
    }
  }
}

export enum OutrasOperacoesPopoverRoleEnum {
  AdicionarProduto = 'Adicionar Produto',
  PagarConta = 'Pagar Conta',
  TransferenciaMesa = 'Transferencia Mesa',
  Imprimir = 'Imprimir',
  CancelarPedido = 'Cancelar Pedido'
}
